import DropItem from "./DropItem";


class DropContainer {


    constructor() {
        this.paragraphTxt = "";
        this.dropItemList = []
        this.styleIndex = 0;
        this.initStyleArr()
        this.selectedStyle = null
        this.dropItemLength = 0;
        this.activityId = -1
    }


    nextStyle = () => {
        if (this.styleIndex < this.styleArr.length - 1) {
            this.styleIndex++;
            this.selectedStyle = this.styleArr[this.styleIndex]
        }
    }

    prevStyle = () => {
        if (this.styleIndex > 0) {
            this.styleIndex--;
            this.selectedStyle = this.styleArr[this.styleIndex]
        }
    }


    getDragListFromIndexString = (dragIndexString, dragList) => {

        dragIndexString = dragIndexString.substr(1);
        dragIndexString = dragIndexString.substr(0, dragIndexString.length - 1);

        let dropIndexArr = dragIndexString.split(",");


        let myDragList = []
        for (let i = 0; i < dropIndexArr.length; i++) {

            if (dropIndexArr[i].trim() != '') {
                let index = parseInt(dropIndexArr[i].trim()) - 1
                if (index < dragList.length) {
                    myDragList.push(dragList[parseInt(dropIndexArr[i].trim()) - 1])
                }

            }
        }

        return myDragList
    }


    getAsJson = () => {
        let obj = {}
        obj.paragraphTxt = this.paragraphTxt
        obj.selectedStyle = this.selectedStyle
        obj.styleIndex = this.styleIndex

        return obj
    }

    initFromJson = (obj) => {
        this.paragraphTxt = obj.paragraphTxtHTML
        this.selectedStyle = obj.selectedStyle
        this.styleIndex = obj.styleIndex
        this.dropItemLength = obj.dropItemLength
        this.styleModification()
    }


    getReportAsJson = () => {
        let obj = {}
        obj.paragraphTxt = this.paragraphTxt
        obj.selectedStyle = this.selectedStyle
        obj.dropItemLength = this.dropItemLength
        obj.dropItemList = []
        
        for(let i=0;i<this.dropItemList.length;i++){
            obj.dropItemList.push(this.dropItemList[i].getReportAsJson())
        }
        
        return obj
    }

    initReportFromJson = (obj) => {
        this.paragraphTxt = obj.paragraphTxt
        this.selectedStyle = obj.selectedStyle
        this.dropItemLength = obj.dropItemLength
        for(let i=0;i<obj.dropItemList.length;i++){
            let dropItem=new DropItem()
            dropItem.initReportFromJson(obj.dropItemList[i])
            this.dropItemList.push(dropItem)
        }

        this.styleModification()
    }



    styleModification = () => {
        this.selectedStyle[0].style.border = "solid 0px black"
        this.selectedStyle[0].style.paddingTop = "0px"

    }

    initStyleArr = () => {
        this.styleArr = [
            { margin: "5px auto", width: "600px", height: "200px", borderRadius: "5px", border: "solid 2px black" },
            { margin: "10px auto", width: "600px", height: "100px", borderRadius: "5px", border: "solid 2px black" },

        ]
    }
}

export default DropContainer